
export const ContentRepository = {
    DOCCENTER: 'doccenter',
    WORKSPACE: 'workspace',
    LIBRARY: 'library',
    LIVEDOC: 'generatedlivedocs',
    CMS: 'cms'
};

// This map to the backend property externalUniqueId (for everything except CMS) which is the real identifier of the content
export const getContentVersionId = (content) => {
    switch (content?.repository?.toString().toLowerCase()) {
    case ContentRepository.DOCCENTER:
        return content?.libraryContent?.versionId || '';
    case ContentRepository.LIBRARY:
    case ContentRepository.WORKSPACE:
        return content?.versionId || '';
    case ContentRepository.LIVEDOC:
        return content?.id || '';
        // we cannot rely on the manifest having externalUniqueId for cms content,
        // so use nodeId to compare content to manifest.
    case ContentRepository.CMS:
        return content?.nodeId || '';
    default:
        return content?.versionId || '';
    }
};
